import styles from "./CarsSummary.module.css";
import { useEffect, useState } from "react";
import getCarsSummary from "../../utils/getCarsSummary";
import Skeleton from "@mui/material/Skeleton";

const AllCarsSummary = ({ isRental }: { isRental: boolean }) => {
  interface Summary {
    totalCars: number;
    tsumodCars: number;
    maagarCars: number;
    rentedCars: number;
    activeRentedCars: number;
    expiredRentedCars: number;
    carsWithFuelCodes: number;
    carsWithoutFuelCodes: number;
  }

  const [summary, setSummary] = useState<Summary | null>(null);
  const [loading, setLoading] = useState(true);
  const [reloadTrigger, setReloadTrigger] = useState(0);

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      try {
        const data = await getCarsSummary();
        setSummary(data);
      } catch (error) {
        console.error("Error fetching cars summary:", error);
      }
      setLoading(false);
    };
    fetchSummary();
  }, [reloadTrigger]);

  // Listen to global reload events (can be triggered from CarsList)
  useEffect(() => {
    const handleReload = () => setReloadTrigger((prev) => prev + 1);
    window.addEventListener("reloadCarsSummary", handleReload);
    return () => window.removeEventListener("reloadCarsSummary", handleReload);
  }, []);

  return (
    <div className={styles.summaryContainer}>
      {loading ? (
        <>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>סה״כ מספרי רכבים:</div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
          {!isRental && (
            <>
              <div className={styles.summaryItem}>
                <div className={styles.summaryItemTitle}>צמודים:</div>
                <div className={styles.summaryItemValue}>
                  <Skeleton variant="rectangular" width={15} height={10} />
                </div>
              </div>
            </>
          )}
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>שכורים:</div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
        </>
      ) : (
        <>
          {!isRental && (
            <>
              <div className={styles.summaryItem}>
                <div className={styles.summaryItemTitle}>סה״כ מספרי רכבים:</div>
                <div className={styles.summaryItemValue}>
                  {summary?.totalCars}
                </div>
              </div>
              <div className={styles.summaryItem}>
                <div className={styles.summaryItemTitle}>צמודים:</div>
                <div className={styles.summaryItemValue}>
                  {summary?.tsumodCars}
                </div>
              </div>
            </>
          )}
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>מאגר:</div>
            <div className={styles.summaryItemValue}>{summary?.maagarCars}</div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>שכורים:</div>
            <div className={styles.summaryItemValue}>{summary?.rentedCars}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default AllCarsSummary;
